<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn :color="color" icon v-on="on" :loading="isLoading">
          <v-badge color="warning" v-if="!currentOrganization" dot>
            <v-icon>{{icon}}</v-icon>
          </v-badge>
          <v-icon v-else>{{icon}}</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list dense>
          <v-subheader>Your Organizations</v-subheader>
          <v-list-item v-for="orga in filteredOrganizations" :key="orga.uuid">
            <v-list-item-title>{{orga.name}}</v-list-item-title>
            <v-list-item-action class="my-0">
              <v-btn icon @click="selectOrganization(orga)">
                <v-icon color="grey lighten-1">check_box_outline_blank</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list dense v-if="currentOrganization">
          <v-subheader>Selected</v-subheader>
          <v-list-item>
            <v-list-item-title>{{currentOrganization.name}}</v-list-item-title>
            <v-list-item-action class="my-0">
              <v-btn icon>
                <v-icon color="success">check_box</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-alert
          v-else
          icon="info"
          text
          border="left"
          type="warning"
          class="ma-0"
          tile
          dense
        >Please select an organization.</v-alert>
        <div class="d-flex justify-center pa-2">
          <v-btn v-if="fetchOrganizationsError" color="warning" @click="refresh" small>
            <v-icon left small dark>refresh</v-icon>
            <span>Refresh</span>
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    menu: false,
    isLoading: false,
    icon: "swap_horiz",
    color: "grey"
  }),
  computed: {
    ...mapState({
      organizations: state => state.organizations.all,
      currentOrganization: state => state.organizations.current,
      fetchOrganizationsError: state => state.organizations.fetchAll.error
    }),
    filteredOrganizations() {
      if (this.organizations && this.currentOrganization) {
        return this.organizations.filter(
          organization => this.currentOrganization.uuid !== organization.uuid
        );
      } else if (this.organizations) {
        return this.organizations;
      }
      return [];
    }
  },
  watch: {
    currentOrganization() {
      if (this.currentOrganization) {
        this.icon = "swap_horiz";
        this.color = "primary";
      }
    }
  },
  methods: {
    ...mapActions("organizations", { fetchAll: "fetchAll" }),
    ...mapActions("organizations", {
      setCurrentOrganization: "setCurrentOrganization"
    }),
    selectOrganization(organization) {
      this.setCurrentOrganization({ organization: organization });
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        if (!this.organizations) {
          this.fetchAll()
            .then(() => {
              (this.icon = "swap_horiz"), (this.color = "grey");
            })
            .catch(() => {
              this.icon = "report_problem";
              this.color = "red";
            })
            .finally(() => (this.isLoading = false));
        }
      }, 1000);
    }
  },
  created() {
    this.refresh();
  }
};
</script>